import { Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { CreateOrganizationDialog } from "components/Organization/CreateOrganizationDialog"
import { OrganizationList } from "components/Organization/OrganizationList"

export function Organizations() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>ORGANIZATIONS</Title>
            </Grid>
            <Grid item>
              <CreateOrganizationDialog />
            </Grid>
          </Grid>
          <OrganizationList />
        </Paper>
      </Grid>
    </Grid>
  )
}
